module.exports = function getFunctionName(f) {
  return f.displayName || f.name || '<function' + f.length + '>';
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form/~/tcomb/lib/getFunctionName.js
 ** module id = 166
 ** module chunks = 0
 **/